<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required, maxLength, helpers } from '@vuelidate/validators';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';
import NextButton from 'next/button/Button.vue';

// checks value matches a simple hostname regex
export default {
  components: {
    NextButton,
    PageHeader,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      name: '',
      number: '',
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
    }),
  },
  validations: {
    name: { required },
    number: {
      required,
      maxLen: maxLength(18),
      format: helpers.regex(/^\+[0-9]{8,}$/),
    },
  },
  methods: {
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }

      try {
        const phoneChannel = await this.$store.dispatch(
          'inboxes/createChannel',
          {
            name: this.name,
            channel: {
              type: 'phone',
              phone_numbers: [this.number],
            },
          }
        );

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: phoneChannel.id,
          },
        });
      } catch (error) {
        useAlert(
          error.message ||
            this.$t('INBOX_MGMT.ADD.PHONE_CHANNEL.API.ERROR_MESSAGE')
        );
      }
    },
  },
};
</script>

<template>
  <div
    class="border border-slate-25 dark:border-slate-800/60 bg-white dark:bg-slate-900 h-full p-6 w-full max-w-full md:w-3/4 md:max-w-[75%] flex-shrink-0 flex-grow-0"
  >
    <PageHeader
      :header-title="$t('INBOX_MGMT.ADD.PHONE_CHANNEL.TITLE')"
      :header-content="$t('INBOX_MGMT.ADD.PHONE_CHANNEL.DESC')"
    />
    <form class="flex flex-wrap mx-0" @submit.prevent="createChannel()">
      <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
        <label :class="{ error: v$.name.$error }">
          {{ $t('INBOX_MGMT.ADD.PHONE_CHANNEL.NAME.LABEL') }}
          <input v-model.trim="name" type="text" @input="v$.name.$touch" />
        </label>
        <p class="help-text">
          {{ $t('INBOX_MGMT.ADD.PHONE_CHANNEL.NAME.SUBTITLE') }}
        </p>
      </div>
      <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
        <label :class="{ error: v$.number.$error }">
          {{ $t('INBOX_MGMT.ADD.PHONE_CHANNEL.PHONE_NUMBER.LABEL') }}
          <input
            v-model.trim="number"
            type="text"
            :placeholder="
              $t('INBOX_MGMT.ADD.PHONE_CHANNEL.PHONE_NUMBER.PLACEHOLDER')
            "
            @input="v$.number.$touch"
          />
        </label>
        <p class="help-text">
          {{ $t('INBOX_MGMT.ADD.PHONE_CHANNEL.PHONE_NUMBER.SUBTITLE') }}
        </p>
      </div>

      <div class="w-full mt-4">
        <NextButton
          :loading="uiFlags.isCreating"
          :label="$t('INBOX_MGMT.ADD.PHONE_CHANNEL.SUBMIT_BUTTON')"
        />
      </div>
    </form>
  </div>
</template>
